import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getAvailablePartners(options = {}) {
	return _apiRequestWrap(
		ModulesMap.PARTNERS,
		ModulesConfigMap[ModulesMap.PARTNERS].GET_AVAILABLE_PARTNERS,
		options
	)
}

export default {
	getAvailablePartners: _getAvailablePartners,
}